import { AppBarDataCustomItem } from '@ihsm/ui-shared';
import * as ROUTES from 'routes';
import { FundDropdown } from '../components/FundDropdown';
import { BenchmarkDropdown } from '../components/BenchmarkDropdown';
import { CurrencyDropdown } from '../components/CurrencyDropdown';
import { LoadedDatePicker } from '../components/LoadedDatePicker';
import { ReloadButton } from '../components/ReloadButton';

export const FUND_OPTION: AppBarDataCustomItem = {
  key: 'fund',
  type: 'customOption',
  component: FundDropdown,
};

export const BENCH_OPTION: AppBarDataCustomItem = {
  key: 'benchmark',
  type: 'customOption',
  component: BenchmarkDropdown,
};

export const CURRENCY_OPTION: AppBarDataCustomItem = {
  key: 'currency',
  type: 'customOption',
  component: CurrencyDropdown,
};

export const LOADED_OPTION: AppBarDataCustomItem = {
  key: 'loaded',
  type: 'customOption',
  component: LoadedDatePicker,
};

export const BUTTON_OPTION: AppBarDataCustomItem = {
  key: 'reload',
  type: 'customOption',
  component: ReloadButton,
};

export const FUNDS_PAGE_OPTIONS = [
  FUND_OPTION,
  CURRENCY_OPTION,
  LOADED_OPTION,
  BUTTON_OPTION,
];

export const BENCHMARK_PAGE_OPTIONS = [
  BENCH_OPTION,
  CURRENCY_OPTION,
  LOADED_OPTION,
  BUTTON_OPTION,
];

export const MAPPING_PAGE_OPTIONS = [LOADED_OPTION, BUTTON_OPTION];

export const PORTFOLIO_FUND_TAB = {
  displayValue: 'Funds',
  path: ROUTES.PORTFOLIOS_FUNDS,
};

export const PORTFOLIO_BENCHMARK_TAB = {
  displayValue: 'Benchmarks',
  path: ROUTES.PORTFOLIOS_BENCHMARKS,
};

export const PORTFOLIO_MAPPING_TAB = {
  displayValue: 'Mapping',
  path: ROUTES.PORTFOLIOS_MAPPINGS,
};

export const FUNDS_TABS = [
  PORTFOLIO_FUND_TAB,
  PORTFOLIO_BENCHMARK_TAB,
  PORTFOLIO_MAPPING_TAB,
];
